export enum PackagingEnum {
    IncludeInMedbox = 'Include in my MedBox',
    Separately = 'Package separately'
}

export const PackagingViewEnum = {
    [PackagingEnum.IncludeInMedbox]: 'Include in medbox roll',
    [PackagingEnum.Separately]: 'Package separately',
}